<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="'임직원 검색'"
      :modal="true"
      :width="'800px'"
      @open="onOpenWindow"
      style="z-index: 10004; transform: scale(1); opacity: 1; display:none;"
  >
    <div class="w100">
      <ul>
        <li class="w100">
          <kendo-tabstrip>
            <ul>
              <li v-show="!$props.isEtnersOnly" @click=""> 삼성 전자 </li>
              <li @click="" class="k-state-active"> 이트너스 </li>
              <li v-show="!$props.isEtnersOnly" @click=""> 삼성전자 협력사 </li>
            </ul>
          </kendo-tabstrip>
        </li>
        <li class="w100 mgt10">
          <kendo-dropdownlist
              class="mgl10 w20"
              ref="searchOptionRef"
              :data-source="searchOptionList"
          >
          </kendo-dropdownlist>
          <kendo-maskedtextbox
              class="mgl10 w60"
              ref="searchValueRef"
              id="searchValue"
              :placeholder="'검색값을 입력해주세요.'"
          >
          </kendo-maskedtextbox>
          <button class="f_r w15 mid_btn orange" @click="commonOnChangeEvent">검색</button>
        </li>
        <li class="w100">
          <kendo-grid
              class="basic_table mgt10"
              ref="userGridRef"
              :columns="sendNmColumns"
              :data-source="userDataSource"
              :selectable="'row'"
              :navigatable="true"
              :filterable="false"
              :sortable="false"
              :scrollable="true"
              :pageable-always-visible="true"
              :reorderable="true"
              :column-menu="false"
              @change="onChangeGrid"
              :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }"
          >
          </kendo-grid>
        </li>
      </ul>
      <div class="w100">

      </div>
    </div>
    <div class="button_area w40">
      <ul>
        <li class="w40"><button class="large_btn orange" @click="emitSendNm">저장</button></li>
        <li class="w40"><button class="large_btn" @click="closeWindow">취소</button></li>
      </ul>
    </div>
  </kendo-window>
</template>

<script>
import ApiConfig from "@/api/api.config";

export default {
  name: "SearchSendNm",
  props: {
    isEtnersOnly : {
      type : Boolean,
      required : false,
      default : function (){
        return false
      }
    },
  },
  created() {
    const vm = this
    vm.getUtopiaUserData()
  },
  mounted() {
    const vm = this
    // vm.getReceiveList()

    //엔터키 이벤트 자동 세팅
    const enterkeyEventTargetIdArray = [
      'searchValue'
    ]

    for (const elementId of enterkeyEventTargetIdArray) {
      const element = document.getElementById(elementId)
      if (element !== undefined) {
        element.onkeyup = function (e) {
          const ENTER_KEY_CODE = 'Enter'
          const NUM_PAD_ENTER = 'NumpadEnter'
          const currentKeyCode = e.code

          if (currentKeyCode === ENTER_KEY_CODE || currentKeyCode === NUM_PAD_ENTER) {
            vm.commonOnChangeEvent(e)
          }
        }
      }
    }
  },
  methods: {

    onOpenWindow () {
      const vm = this

      // 검색 칸 초기화
      vm.$refs.searchOptionRef.kendoWidget().select(0)
      vm.$refs.searchValueRef.kendoWidget().value('')
      vm.getUtopiaUserData()
    },

    commonOnChangeEvent () {
      const gridRefs = this.$refs.userGridRef

      if (gridRefs !== undefined && gridRefs.kendoWidget() !== undefined) {
        gridRefs.kendoWidget().dataSource.page(1)
      }
    },

    currentPageFilterOption () {
      const refs = this.$refs

      let filterOption = {}

      let searchValue = ""
      if (refs.searchValueRef !== undefined && refs.searchValueRef !== null) {
        searchValue = refs.searchValueRef.kendoWidget().value()
      }

      if (refs.searchOptionRef !== undefined && refs.searchOptionRef !== null) {
        const searchOption = refs.searchOptionRef.kendoWidget().value()
        if (searchOption === '이름') {
          filterOption.searchUserNm = searchValue
        } else if (searchOption === '부서') {
          filterOption.searchDeptNm = searchValue
        } else if (searchOption === '아이디') {
          filterOption.searchUserId = searchValue
        } else if (searchOption === '번호') {
          filterOption.searchUserTelNo = searchValue
        }
      }

      return filterOption
    },

    getUtopiaUserData () {
      const vm = this
      vm.userDataSource = new kendo.data.DataSource({

        name: 'userDataSource',
        page: 1,
        pageSize: 5,
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            url: `${ApiConfig.esccDomain}/v1/esp/ecc/employee/getUserListForEsai.json`,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            cache: false
          },
          parameterMap: function(options, operation) {
            if (operation === 'read') {

              const paramToKendoFilters = vm.currentPageFilterOption()
              const params = {
                esaiLoginUserToken: vm.loginUserToken,
                skip: options.skip,
                take: options.take,
                sort: options.sort,
                page: options.page,
                pageSize: options.pageSize,
                searchUserNm: paramToKendoFilters.searchUserNm,
                searchDeptNm: paramToKendoFilters.searchDeptNm,
                searchUserId: paramToKendoFilters.searchUserId,
                searchUserTelNo: paramToKendoFilters.searchUserTelNo,
              }

              return kendo.stringify(params)
            }

            if (operation !== 'read' && options.models) {
              return {models: kendo.stringify(options.models)}
            }
          }
        },
        schema: {
          type: 'json',
          parse: function(response) {
            if (response.resultStatus.messageCode !== '2000') {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }

            const changeResultData = response.resultData
            let rowNumber = response.total > 1 ? response.total - ((vm.$refs.userGridRef
                .dataSource.page() - 1) * vm.$refs.userGridRef.dataSource.pageSize()) : response.total

            if (changeResultData === null) {
              return false
            }

            for (let i = 0; i < changeResultData.length; i++) {
              const row = changeResultData[i]
              // row 번호 내림차순 셋팅
              row.rowNumber = rowNumber--
            }

            //status 상태 값 받아오기
            response.resultData = changeResultData
            return response
          },

          total: function(response) {
            return response.total
          },

          data: function(response) {
            // 카테고리 seq 순으로 배열 선언
            if (response.resultStatus.messageCode === '2000') {
              return response.resultData
            }
          }
        },
        error: function(e) {
          // console.log('error event handler', e.errors)
        }
      })
    },

    onChangeGrid (e) {
      const vm = this

      const selectedRow = e.sender.select()
      const item = e.sender.dataItem(selectedRow)

      vm.senderData = item
    },

    emitSendNm () {
      const vm = this
      const refs = vm.$refs

      vm.$emit('getSenderData', {
        userNm: vm.senderData.userNm,
        userId: vm.senderData.userId,
        dept: vm.senderData.deptNm,
        spTelNo: vm.senderData.userTelNo,
        sabun: vm.senderData.utopiaWorkId,
      })
      refs.kendoWindowRef.kendoWidget().close()
    },

    closeWindow () {
      const vm = this
      const refs = vm.$refs
      vm.senderData = {}

      refs.kendoWindowRef.kendoWidget().close()
    }
  },
  data () {
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }

    return {
      loginUserToken: sessionStorage.getItem("loginUserToken"),
      senderData : {},

      searchOptionList : [
          '이름', '부서', '아이디', '번호'
      ],

      userDataSource : [],
      sendNmColumns : [
        {
          field: 'userNm',
          title: '이름',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'deptNm',
          title: '부서',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'userId',
          title: '아이디',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'userTelNo',
          title: '번호',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
      ]
    }
  }
}
</script>

<style scoped>

</style>
